import React from 'react';
import { Box, Grid, Typography, Table, TableHead, TableRow, TableCell, TableBody, Chip } from '@mui/material';
import { DrillDownData } from '../../types/productDrillDown';
import { formatCurrency, formatNumber } from '../DrillDown/formatters';

const ProductDrillDownContent: React.FC<{ data: DrillDownData }> = ({ data }) => {
  const { produto, transacoes_por_mes, top_cfops, parceiros_comerciais } = data;

  return (
    <Box sx={{ p: 2 }}>
      {/* Estatísticas Gerais */}
      <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 600 }}>Informações do Produto</Typography>
      <Grid container spacing={2} sx={{ mb: 4 }}>
        <Grid item xs={12} sm={6} md={3}>
          <Chip label={`Código: ${produto?.cod_item || 'N/A'}`} color="primary" />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Chip label={`Crédito Total ICMS: ${formatCurrency(produto?.total_credito_icms || 0)}`} color="success" />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Chip label={`Débito Total ICMS: ${formatCurrency(produto?.total_debito_icms || 0)}`} color="warning" />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Chip label={`Quantidade Total: ${formatNumber(produto?.quantidade_total || 0)}`} color="info" />
        </Grid>
      </Grid>

      {/* Evolução por Período */}
      <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 600 }}>Evolução por Período</Typography>
      <Table size="small" sx={{ mb: 4 }}>
        <TableHead>
          <TableRow>
            <TableCell>Período</TableCell>
            <TableCell align="right">Crédito ICMS</TableCell>
            <TableCell align="right">Quantidade Entrada</TableCell>
            <TableCell align="right">Valor Compra</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {transacoes_por_mes?.map((item, index) => (
            <TableRow key={index}>
              <TableCell>{`${item.mes}/${item.ano}`}</TableCell>
              <TableCell align="right">{formatCurrency(item.credito_icms)}</TableCell>
              <TableCell align="right">{formatNumber(item.quantidade_entrada)}</TableCell>
              <TableCell align="right">{formatCurrency(item.valor_total_item)}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>

      {/* Top CFOPs */}
      <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 600 }}>Top CFOPs</Typography>
      <Table size="small" sx={{ mb: 4 }}>
        <TableHead>
          <TableRow>
            <TableCell>CFOP</TableCell>
            <TableCell align="right">Total ICMS</TableCell>
            <TableCell align="right">Transações</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {top_cfops?.map((c, index) => (
            <TableRow key={index}>
              <TableCell>{c.cfop}</TableCell>
              <TableCell align="right">{formatCurrency(c.total_icms)}</TableCell>
              <TableCell align="right">{formatNumber(c.total_transacoes)}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>

      {/* Top Fornecedores */}
      <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 600 }}>Top Fornecedores</Typography>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>Fornecedor</TableCell>
            <TableCell align="right">Total Compras</TableCell>
            <TableCell align="right">ICMS Compras</TableCell>
            <TableCell align="right">Quantidade</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {parceiros_comerciais?.fornecedores?.map((f, index) => (
            <TableRow key={index}>
              <TableCell>{f.nome}</TableCell>
              <TableCell align="right">{formatCurrency(f.total_compras)}</TableCell>
              <TableCell align="right">{formatCurrency(f.icms_compras)}</TableCell>
              <TableCell align="right">{formatNumber(f.quantidade_comprada)}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Box>
  );
};

export default ProductDrillDownContent; 